module.exports = __webpack_public_path__ + "static/img/banner2.93fd92a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner2.jpeg
// module id = RXql
// module chunks = 4